import React from "react";

const styles = {
  wrapper: {
    padding: "40px 20px",
    backgroundColor: "#fff",
    fontFamily: "Arial, sans-serif",
    lineHeight: 1.6,
    color: "#333",
    maxWidth: "900px",
    margin: "0 auto",
  },
  heading1: {
    fontSize: "32px",
    fontWeight: "bold",
    marginBottom: "20px",
  },
  heading2: {
    fontSize: "24px",
    fontWeight: "bold",
    marginTop: "30px",
    marginBottom: "15px",
  },
  heading3: {
    fontSize: "20px",
    fontWeight: "bold",
    marginTop: "20px",
    marginBottom: "10px",
  },
  heading4: {
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "15px",
    marginBottom: "10px",
  },
  paragraph: {
    marginBottom: "15px",
  },
  list: {
    paddingLeft: "20px",
    marginBottom: "15px",
  },
  listItem: {
    marginBottom: "10px",
  },
  link: {
    color: "#007bff",
    textDecoration: "none",
  },
  emailLink: {
    color: "#007bff",
    textDecoration: "underline",
  },
};

const PrivacyPolicy = () => {
  return (
    <div style={styles.wrapper}>
      <h1 style={styles.heading1}>Privacy Policy for ROHA Raahi</h1>
      <p style={styles.paragraph}>Last updated: June 27, 2025</p>

      <p style={styles.paragraph}>
        This Privacy Policy describes Our policies and procedures on the
        collection, use and disclosure of Your information when You use the
        Service and tells You about Your privacy rights and how the law protects
        You.
      </p>
      <p style={styles.paragraph}>
        We use Your Personal data to provide and improve the Service. By using
        the Service, You agree to the collection and use of information in
        accordance with this Privacy Policy.
        .
      </p>

      <h2 style={styles.heading2}>Interpretation and Definitions</h2>
      <h3 style={styles.heading3}>Interpretation</h3>
      <p style={styles.paragraph}>
        The words of which the initial letter is capitalized have meanings
        defined under the following conditions. The following definitions shall
        have the same meaning regardless of whether they appear in singular or
        in plural.
      </p>

      <h3 style={styles.heading3}>Definitions</h3>
      <p style={styles.paragraph}>For the purposes of this Privacy Policy:</p>
      <ul style={styles.list}>
        {[
          ["Account", "A unique account created for You to access our Service or parts of our Service."],
          ["Affiliate", "An entity that controls, is controlled by or is under common control with a party."],
          ["Application", "Refers to Roha Raahi, the software program provided by the Company."],
          [
            "Company",
            "Refers to Roha Housing Finance Private Limited, Unit No. 1117 & 1118, 11th Floor, World Trade Tower, Sector – 16, Noida – 201301, Uttar Pradesh, India.",
          ],
          ["Country", "Refers to Uttar Pradesh, India."],
          ["Device", "Any device that can access the Service such as a computer, a cellphone or a digital tablet."],
          ["Personal Data", "Any information that relates to an identified or identifiable individual."],
          ["Service", "Refers to the Application."],
          [
            "Service Provider",
            "Any natural or legal person who processes the data on behalf of the Company.",
          ],
          ["Usage Data", "Data collected automatically, either generated by the use of the Service or from the Service infrastructure itself."],
          [
            "You",
            "The individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service.",
          ],
        ].map(([term, description], index) => (
          <li key={index} style={styles.listItem}>
            <strong>{term}</strong>: {description}
          </li>
        ))}
      </ul>

      <h2 style={styles.heading2}>Collecting and Using Your Personal Data</h2>
      <h3 style={styles.heading3}>Types of Data Collected</h3>
      <h4 style={styles.heading4}>Personal Data</h4>
      <p style={styles.paragraph}>We may collect personally identifiable information such as:</p>
      <ul style={styles.list}>
        <li style={styles.listItem}>Email address</li>
        <li style={styles.listItem}>Phone number</li>
        <li style={styles.listItem}>Usage Data</li>
      </ul>

      <h4 style={styles.heading4}>Usage Data</h4>
      <p style={styles.paragraph}>
        Usage Data may include your IP address, browser type/version, pages visited, time spent, device identifiers, etc.
      </p>

      <h4 style={styles.heading4}>Information Collected while Using the Application</h4>
      <p style={styles.paragraph}>With your permission, we may collect:</p>
      <ul style={styles.list}>
        <li style={styles.listItem}>Location data</li>
        <li style={styles.listItem}>Camera and photo library access</li>
      </ul>

      <h3 style={styles.heading3}>Use of Your Personal Data</h3>
      <p style={styles.paragraph}>Your data may be used for:</p>
      <ul style={styles.list}>
        <li style={styles.listItem}>Providing and maintaining the service</li>
        <li style={styles.listItem}>Account management</li>
        <li style={styles.listItem}>Fulfilling contractual obligations</li>
        <li style={styles.listItem}>Communications (email, SMS, notifications)</li>
        <li style={styles.listItem}>Marketing & promotional offers</li>
        <li style={styles.listItem}>Customer support</li>
        <li style={styles.listItem}>Analytics and improvements</li>
        <li style={styles.listItem}>Business transfers</li>
      </ul>

      <h3 style={styles.heading3}>Data Sharing</h3>
      <ul style={styles.list}>
        <li style={styles.listItem}>With service providers</li>
        <li style={styles.listItem}>For business transfers</li>
        <li style={styles.listItem}>With affiliates and partners</li>
        <li style={styles.listItem}>With your consent</li>
      </ul>

      <h3 style={styles.heading3}>Retention and Transfer</h3>
      <p style={styles.paragraph}>
        We retain data as long as necessary. Data may be transferred outside your jurisdiction but will be protected.
      </p>

      <h3 style={styles.heading3}>Your Rights</h3>
      <p style={styles.paragraph}>
        You can update or delete your data by accessing your account or contacting us.
      </p>

      <h3 style={styles.heading3}>Legal Disclosure</h3>
      <ul style={styles.list}>
        <li style={styles.listItem}>To comply with legal obligations</li>
        <li style={styles.listItem}>To protect rights and safety</li>
      </ul>

      <h3 style={styles.heading3}>Security</h3>
      <p style={styles.paragraph}>
        We strive to use secure measures but no method of transmission is completely secure.
      </p>

      <h2 style={styles.heading2}>Children's Privacy</h2>
      <p style={styles.paragraph}>
        We do not knowingly collect information from anyone under 13. Contact us if you believe we have.
      </p>

      <h2 style={styles.heading2}>External Links</h2>
      <p style={styles.paragraph}>
        Our service may contain links to external websites. We are not responsible for their content or privacy practices.
      </p>

      <h2 style={styles.heading2}>Policy Updates</h2>
      <p style={styles.paragraph}>
        We may update this policy. Updates will be posted here with a new date.
      </p>

      <h2 style={styles.heading2}>Contact Us</h2>
      <p style={styles.paragraph}>
        If you have questions, contact us at:{" "}
        <a href="mailto:it11@rohahousing.com" style={styles.emailLink}>
          it11@rohahousing.com
        </a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
